type TlCookie = { first_name: string; last_name: string; site: string; domain: string };

const accountCookieHandler = (): void => {
  // from https://gist.github.com/hunan-rostomyan/28e8702c1cecff41f7fe64345b76f2ca
  const getCookie = (name: string): TlCookie | null => {
    const nameLenPlus = name.length + 1;
    const decodedCookie =
      document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => cookie.substring(0, nameLenPlus) === `${name}=`)
        .map(cookie => decodeURIComponent(cookie.substring(nameLenPlus)))[0] || null;

    if (!decodedCookie) return null;

    let parsedCookie;
    try {
      parsedCookie = JSON.parse(decodedCookie);
      // The space character is serialized with a '+' sign.
      // decodeURIComponent() only replaces spaces that were serialized with a '%20'.
      parsedCookie.site = parsedCookie.site.replace('+', ' ');
    } catch (e) {
      console.error(`Error parsing cookie\n${e}`);
    }
    return parsedCookie;
  };

  const updateUserDisplay = (cookie: TlCookie, disconnectTranslation = 'Déconnexion'): void => {
    const accountDiv = document.getElementById('tl-account');
    if (!accountDiv) return;

    accountDiv.innerHTML = `
         <details class='tl-account'>
          <summary>
            <svg class='icon icon-profile' aria-hidden='true'>
                <use xlink:href='#profile'></use>
            </svg>
            <span title='${cookie.first_name} ${cookie.last_name}'>${cookie.first_name} ${cookie.last_name}</span>
          </summary>
          <div>
            <ul>
              <li><a href='https://${cookie.domain}' class='tl-link'>${cookie.site}</a></li>
              <li><a href='https://${cookie.domain}/fr/account/login/logout' class='tl-link'>${disconnectTranslation}</a></li>
            </ul>
          </div>
        </details>
      `;
  };

  const tlAccount = document.getElementById('tl-account');
  const { tlConnectedCookieName, translationDisconnect } = tlAccount?.dataset as {
    tlConnectedCookieName: string;
    translationDisconnect: string;
  };

  if (tlConnectedCookieName && tlAccount) {
    const tlCookie = getCookie(tlConnectedCookieName);
    if (tlCookie) {
      updateUserDisplay(tlCookie, translationDisconnect);
    }
  }
};

export default accountCookieHandler;
